"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAuthenticationService = void 0;
/* istanbul ignore file */
const auth0_js_1 = __importDefault(require("auth0-js"));
const __1 = require("..");
const domain_1 = require("../../../domain");
const mappers_1 = require("../mappers");
const lodash_1 = __importDefault(require("lodash"));
const aws_amplify_1 = require("aws-amplify");
const Sentry = __importStar(require("@sentry/react"));
const DEFAULT_LOCALE = 'fr';
const SCOPES = ['aws.cognito.signin.user.admin', 'email', 'profile', 'openid'];
let auth0;
class FAuthenticationService {
    constructor(apolloClient) {
        this.apolloClient = apolloClient;
    }
    initializeCognitoClient(config) {
        aws_amplify_1.Amplify.configure({
            Auth: {
                userPoolId: config.COGNITO_USER_POOL_ID,
                userPoolWebClientId: config.COGNITO_USER_POOL_CLIENT_ID,
                region: config.COGNITO_REGION,
                oauth: {
                    domain: config.COGNITO_DOMAIN,
                    scope: SCOPES,
                    redirectSignIn: config.COGNITO_REDIRECT_SIGN_IN,
                    redirectSignOut: config.COGNITO_REDIRECT_SIGN_OUT,
                    responseType: 'code',
                },
            }
        });
    }
    login(config) {
        try {
            const locale = DEFAULT_LOCALE;
            const scopesString = SCOPES.join(' ');
            const queryString = Object.entries({
                redirect_uri: config.COGNITO_REDIRECT_SIGN_IN,
                response_type: config.COGNITO_RESPONSE_TYPE,
                client_id: config.COGNITO_USER_POOL_CLIENT_ID,
                scope: scopesString,
                lang: locale
            })
                .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
                .join('&');
            const url = `https://${config.COGNITO_DOMAIN}/oauth2/authorize?${queryString}`;
            window.location.assign(url);
        }
        catch (error) {
            Sentry.captureException(error, {
                tags: {
                    module: "FAuthenticationService",
                    method: "login",
                    cognito: "error",
                },
            });
            throw new domain_1.AuthenticationServiceErrors.LoginRequestError("LOGIN_REQUEST_FAILED", error);
        }
    }
    retrieveTokens({ authResultCallBack, authErrorCallback, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const session = yield aws_amplify_1.Auth.currentSession();
                const authResult = {
                    accessToken: session.getAccessToken().getJwtToken(),
                    idToken: session.getIdToken().getJwtToken(),
                    refreshToken: session.getRefreshToken().getToken(),
                    expiresIn: session.getAccessToken().getExpiration(),
                };
                authResultCallBack(authResult);
            }
            catch (error) {
                // @ts-ignore
                authErrorCallback(error);
            }
        });
    }
    refreshToken() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield aws_amplify_1.Auth.currentAuthenticatedUser({ bypassCache: true });
            }
            catch (error) { }
            aws_amplify_1.Auth.currentSession().then((session) => {
                const authResult = {
                    accessToken: session.getAccessToken().getJwtToken(),
                    idToken: session.getIdToken().getJwtToken(),
                    refreshToken: session.getRefreshToken().getToken(),
                    expiresIn: session.getAccessToken().getExpiration(),
                };
                resolve(new Response(JSON.stringify(authResult), {
                    status: 200,
                    statusText: 'OK',
                }));
            }).catch((error) => {
                // @ts-ignore
                reject(error);
            });
        }));
    }
    /**
     * @deprecated
     * This method is deprecated and will be removed in the future.
     * @param config
     */
    initializeAuth0Client(config) {
        auth0 = new auth0_js_1.default.WebAuth({
            audience: config.AUTH0_WEB_AUDIENCE,
            clientID: config.AUTH0_WEB_CLIENT_ID,
            domain: config.AUTH0_WEB_DOMAIN,
            redirectUri: config.POINTAGE ? `${config.WEB_BASE_URL}/callback` : `${config.WEB_BASE_URL}/authentication-callback`,
            responseType: config.AUTH0_WEB_RESPONSE_TYPE,
        });
    }
    deleteAccount(input) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.apolloClient.mutate({
                    mutation: __1.DELETE_USER_ACCOUNT,
                    variables: input,
                });
                return Promise.resolve(response);
            }
            catch (error) {
                return Promise.reject(new domain_1.AuthenticationServiceErrors.DeleteAccountRequestError("DELETE_ACCOUNT_REQUEST_FAILED", error));
            }
        });
    }
    checkEmail(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const checkEmailMapper = new mappers_1.CheckEmailMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.CHECK_EMAIL,
                    variables,
                    fetchPolicy: "network-only",
                });
                return Promise.resolve(checkEmailMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.AuthenticationServiceErrors.CheckEmailRequestError("CHECK_EMAIL_REQUEST_FAILED", error));
            }
        });
    }
    signUp(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const signUpMapper = new mappers_1.SignUpMapper();
            try {
                const response = yield this.apolloClient.mutate({
                    mutation: __1.SIGNUP,
                    variables,
                });
                return Promise.resolve(signUpMapper.toDomain(response));
            }
            catch (error) {
                const errorMessage = lodash_1.default.get(error, "graphQLErrors[0].extensions.original.details[0].message");
                if (errorMessage === "The associated ressource was not found") {
                    return {
                        hasError: true,
                        errorMessage,
                    };
                }
                return Promise.reject(new domain_1.AuthenticationServiceErrors.SignUpRequestError("SIGNUP_REQUEST_FAILED", error));
            }
        });
    }
    /**
     * @deprecated
     * This method is deprecated and will be removed in the future.
     * @param config
     */
    loginSSO(config) {
        try {
            auth0.authorize({
                prompt: config.AUTH0_APP_PROMPT,
                login_hint: config.email,
                redirectUri: `${config.WEB_BASE_URL}/authentication-callback`,
                state: "sso",
            });
        }
        catch (error) {
            throw new domain_1.AuthenticationServiceErrors.LoginRequestError("LOGIN_SSO_REQUEST_FAILED", error);
        }
    }
    loginIDP(code) {
        return __awaiter(this, void 0, void 0, function* () {
            const idpSSOMapper = new mappers_1.IDPSSOMapper();
            try {
                const response = yield this.apolloClient.mutate({
                    mutation: __1.IDP_SSO,
                    variables: { input: { code } },
                });
                return Promise.resolve(idpSSOMapper.toDomain(response));
            }
            catch (error) {
                throw new domain_1.AuthenticationServiceErrors.LoginRequestError("LOGIN_IDP_REQUEST_FAILED", error);
            }
        });
    }
    codeExchange(code) {
        return __awaiter(this, void 0, void 0, function* () {
            const codeExchangeMapper = new mappers_1.CodeExchangeMapper();
            try {
                const response = yield this.apolloClient.mutate({
                    mutation: __1.CODE_EXCHANGE,
                    variables: { input: { code } },
                });
                return Promise.resolve(codeExchangeMapper.toDomain(response));
            }
            catch (error) {
                throw new domain_1.AuthenticationServiceErrors.LoginRequestError("CODE_EXCHANGE_REQUEST_FAILED", error);
            }
        });
    }
    /**
     * @deprecated
     * This method is deprecated and will be removed in the future.
     * @param config
     */
    sendResetPasswordEmail(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseURL = `https://${request.AUTH0_WEB_DOMAIN}/${request.AUTH0_WEB_RESET_PASSWORD}`;
            const body = {
                client_id: request.AUTH0_WEB_CLIENT_ID,
                email: request.email,
                connection: request.AUTH0_WEB_CONNECTION,
            };
            try {
                const response = yield window.fetch(baseURL, {
                    method: "post",
                    headers: {
                        Accept: "application/json, text/json, */*",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(body),
                });
                if (response.status !== 200) {
                    throw Error;
                }
                return Promise.resolve(response.status);
            }
            catch (error) {
                return Promise.reject(new domain_1.AuthenticationServiceErrors.SendResetPasswordEmail("SEND_RESET_PASSWORD_EMAIL_ERROR", error));
            }
        });
    }
}
exports.FAuthenticationService = FAuthenticationService;
